<template>
  <div
    class="container"
    :class="{is_mirror: isMirror}"
  >
    <TicketCommon
      v-if="tempTicket"
      ref="tempTicket"
      :class="[showTempTicket ? 'show' : 'hide']"
      :ticket="tempTicket"
    />
    <div class="top">
      <div class="tickets" :style="{order: isMirror ? '1' : '0'}">
        <div
          v-for="(item, index) in currentItems"
          :key="item ? item.id : -(index + 1)"
          class="infoscreen-item"
          :style="{
            borderColor: 'transparent',
            backgroundColor: 'transparent',
          }"
        >
          <TicketCommon v-if="item" ref="ticket" :ticket="item" />
        </div>
      </div>
      <div class="frame">
        <PlaylistFrame :playlist="$store.deviceStartData.main_play_list" :playlist-type="'main'" />
      </div>
    </div>
  </div>
</template>

<script>
import TicketCommon from '../tickets/TicketCommon';
import PlaylistFrame from '../PlaylistFrame';
import TemplateMixin from '../../mixins/TemplateMixin';
import PLAYLIST_TYPE from '../../constants/PlaylistType';

export default {
  name: 'TemplateFullFrame',
  components: {
    TicketCommon,
    PlaylistFrame
  },
  mixins: [TemplateMixin],
  props: {
    isMirror: Boolean,
    isAdditionalFrame: Boolean
  },
  data() {
    return {
      PLAYLIST_TYPE: PLAYLIST_TYPE
    };
  },
  computed: {
    currentItems() {
      console.log(this.getCurrentTickets(4))
      return this.getCurrentTickets(4);
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
}

.top {
  position: relative;
  height: 100%;

  .frame {
    // flex-grow: 1;
    height: 100%;
    width: 100%;
  }

  .tickets {
    display: flex;
    height: 23%;
    min-height: 23%;
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: 1;

    .infoscreen-item {
      width: 25%;
      height: 100%;

      &:not(:first-child) {
        border-left-style: solid;
      }
    }
  }
}

.infoscreen-item {
  border-width: 4px;
  border-width: max(0.21vw, 4px);
}

.playlist-wrapper,
.widget {
  flex-grow: 1;
}

.widget-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

// .bottom {
//   display: flex;
//   height: 25%;

//   .infoscreen-item {
//     height: 100%;
//     width: 25%;
//     min-width: 25%;

//     &:not(:last-child) {
//       border-right-style: solid;
//     }
//   }
// }

.show {
  display: flex;
}

.hide {
  display: none;
}
</style>
